import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';
import { readableColor, darken, lighten } from 'polished';

const ActivityItem = styled.div`
  width: 100px;
  height: 20px;
  border-radius: 2px;
  overflow: hidden;
  margin-right: 10px;
  color: ${props => (props.color ? readableColor(darken(0.2, props.color)) : '#000')};
  font-size: 12px;
  box-shadow: ${props => (!props.itemInCoach ? !props.filtered && '-2px 3px 6px rgba(0, 0, 0, 0.25)' : null)};
  background-color: ${props => {
    if (props.filtered && !props.itemInCoach) {
      return lighten(0.3, props.color);
    }
    return props.color ? props.color : null;
  }};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${props => (props.onClick ? 'pointer' : 'default')};
  &:last-child {
    margin-right: 0;
  }
`;

const ActivityGroupItem = ({ item, onClick, filters, itemInCoach }) =>
  item ? (
    <ActivityItem
      color={item.activityGroup ? item.activityGroup.colorCode : item.colorCode}
      onClick={onClick}
      filtered={!!filters && filters.includes(item.id)}
      itemInCoach={itemInCoach}
    >
      {item.name}
    </ActivityItem>
  ) : null;

ActivityGroupItem.propTypes = {
  item: PropTypes.shape({}).isRequired,
  onClick: PropTypes.func,
  filters: PropTypes.arrayOf(PropTypes.number),
  itemInCoach: PropTypes.bool.isRequired
};

ActivityGroupItem.defaultProps = {
  onClick: () => {},
  filters: []
};

export default ActivityGroupItem;



// WEBPACK FOOTER //
// ./src/components/ActivityGroupItem/ActivityGroupItem.jsx